import { render, staticRenderFns } from "./brieHeader.vue?vue&type=template&id=f7104c9a&scoped=true"
import script from "./brieHeader.vue?vue&type=script&lang=js"
export * from "./brieHeader.vue?vue&type=script&lang=js"
import style0 from "./brieHeader.vue?vue&type=style&index=0&id=f7104c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7104c9a",
  null
  
)

export default component.exports